import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { axios } from '@repo/http';
import { GET_USER_APPLICATION_LIST_PATH, get_user_application_list_path } from 'ze-api-contract/user-v2/get-user-application-list';
export const userApplicationListQuery = createQueryKeys('user', {
    applicationList: (param)=>{
        let { userEmail, queryParams } = param;
        return {
            queryKey: [
                GET_USER_APPLICATION_LIST_PATH,
                userEmail,
                queryParams
            ],
            queryFn: async ()=>{
                // TODO: change in other queries too because using undefined results in dev error
                if (!userEmail) {
                    return Promise.resolve(null);
                }
                return axios.get(get_user_application_list_path({
                    userEmail
                }), {
                    params: queryParams
                }).then((res)=>res.data.entities);
            }
        };
    }
});
export const useUserApplicationList = (params)=>{
    const { data: applicationList, isLoading, error } = useQuery(userApplicationListQuery.applicationList(params));
    return {
        applicationList,
        isLoading,
        error
    };
};
